import React from "react";
import HeroArea from "./HeroArea";
import PropertiesDetailsArea from "./PropertiesDetailsArea";

const PropertiesDetails = () => {
  return (
    <>
      <HeroArea />
      <PropertiesDetailsArea />
    </>
  );
};

export default PropertiesDetails;
